/* eslint-disable func-names */
/* eslint-disable no-case-declarations */
import * as Sentry from '@sentry/react';
import { clarity } from 'react-microsoft-clarity';
import cookie from 'react-cookies';

import {
  FETCH_USER_PROFILE,
  AUTH_PROFILE_UPDATE,
  FETCH_TRANSLATIONS,
  CHECK_MODULE_PERMISSIONS
} from './types';
import { environ } from '../../..';

const INITIAL_STATE = {
  profile: {},
  translations: {},
  tileOrder: false,
  leaseDocumentPermission: false,
  avpModulePermission: false
};

let clarityStarted = false;

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_USER_PROFILE.success:
      localStorage.setItem('airportId', action.payload.portal_airport.code);
      localStorage.setItem('timeFormat', action.payload.portal_airport?.airport_settings?.time_format === '24' ? 'HH:mm' : 'hh:mm A');
      localStorage.setItem('dateFormat', action.payload.portal_airport?.airport_settings?.date_format || 'MM/DD/YYYY');
      localStorage.setItem('userId', action.payload.user.username);
      let leaseDocumentPermission = false;
      let avpModulePermission = false;
      const data = action.payload;
      if (data.user) {
        const scope = Sentry.getCurrentScope();
        scope.setUser({ id: data.id, username: data.user.username, email: data.user.email, fullname: data.fullname, phone: data.phone });
        if (data.portal_airport) {
          scope.setTag('backend.id', data.portal_airport.backend_id);
          scope.setTag('user.name', data.fullname);
          scope.setTag('user.phone', data.phone);
          scope.setTag('user.first_name', data.first_name);
          scope.setTag('user.last_name', data.last_name);
          scope.setTag('user.email_domain', data.user.email.split('@')[1]);
          scope.setTag('user.email', data.user.email);
          scope.setTag('airport.name', data?.portal_airport?.name || '');
          scope.setTag('airport.code', data?.portal_airport?.code || '');
          scope.setTag('airport.iata', data?.portal_airport?.iata_code || '');
          scope.setTag('airport.country', data?.portal_airport?.country_code || '');
        }
        // scope.setExtra();
        if (
          process.env.REACT_APP_CLARITY_ENABLED
          && process.env.REACT_APP_CLARITY_ENABLED === 'true'
          && cookie.load('disableClarity') !== 'true'
          && localStorage.getItem('disableClarity') !== 'true'
        ) {
          try {
            if (!clarityStarted) {
              clarityStarted = true;
              clarity.init(
                process.env.REACT_APP_CLARITY_KEY
                  ? process.env.REACT_APP_CLARITY_KEY
                  : 'ldjyjcsuxd'
              );
              window.clarity('identify', data.phone);
              window.clarity('set', 'email', data.user.email);
              window.clarity('set', 'env', environ);
              window.clarity('set', 'name', data.fullname);
              window.clarity('set', 'first_name', data.first_name);
              window.clarity('set', 'last_name', data.last_name);
              window.clarity('set', 'email_domain', data.user.email?.split('@')[1]);
              window.clarity('set', 'airport_name', data.portal_airport?.name);
              window.clarity('set', 'airport_code', data.portal_airport?.code);
              window.clarity('set', 'backend_id', data.portal_airport?.backend_id);
            }
          } catch (ex) {
            // do nothing for now
          }
        }
        leaseDocumentPermission = action.payload?.permissions?.is_portal_sign;
        avpModulePermission = action.payload?.permissions?.vehicle_permit?.length > 0;
      }
      return {
        ...state,
        profile: action.payload,
        leaseDocumentPermission,
        avpModulePermission
      };
    case FETCH_USER_PROFILE.error:
      return state;
    case AUTH_PROFILE_UPDATE:
      return state;
    case FETCH_TRANSLATIONS.success:
      return {
        ...state,
        translations: action.payload
      };
    case FETCH_TRANSLATIONS.error:
      return {
        ...state,
        translations: {}
      };
    case CHECK_MODULE_PERMISSIONS:
      const permitEnabled = action.payload.find(val => val?.key === 'permit_management')?.enabled;
      const badgeEnabled = action.payload.find(val => val?.key === 'badging')?.enabled;
      const gateEnabled = action.payload.find(val => val?.key === 'gate_management')?.enabled;
      const someModulePermission ={
        permitEnabled, badgeEnabled, gateEnabled
      };
      return {
        ...state,
        someModulePermission
      };
    default:
      return state;
  }
}
